import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { disableSubNavbar } from '../actions/navbar';
import { BASE_URL, createRequestProperties } from '../actions/helper';

import List from '../components/list/List';
import DestinationListItem from '../components/destination/DestinationListItem';
import { requestDestinationList } from '../actions/destination';
import SearchTools from '../components/search/SearchTools';
import InstallationDocumentModalItem from '../components/destination/InstallationDocumentModalItem';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      limit: 10,
      maxRecord: 100,
      isLastPage: false,
      selectedCustomersFilterItems: [],
      isDataLoading: false,
      destinationFilters: {
        customerName: '',
        endCustomerName: '',
        searchTerms: '',
      },
      searched: false,
      searchText: '',
      installationDocuments: [],
      showOnlyInstallationDocuments: false,
      mainMenuClicked: this.props.mainMenuClicked,
      resetSearchTermBtn: false,
    };
  }

  componentDidMount() {
    const { page, limit } = this.state;
    const { destinationList } = this.props;
    const { disableSubNavbar, requestDestinationList } = this.props;

    this.customPerPageNumberBox();
    disableSubNavbar();

    if (!destinationList) {
      requestDestinationList(page, limit);
    }

    this.resetEverything();
  }

  getFilteredDestinations() {
    const { destinationList = [] } = this.props;
    const {
      destinationFilters, limit, isLastPage, resetSearchTermBtn,
    } = this.state;
    const { endCustomerName = '', searchTerms, selectedCustomer = [] } = destinationFilters;
    const filters = [];

    if (selectedCustomer !== undefined && selectedCustomer.length > 0) {
      filters.push((destination) => (this.filterByCustomerName(destination, selectedCustomer)));
    }

    if (endCustomerName) {
      filters.push((destination) => (this.filterByEndCustomerName(destination, endCustomerName)));
    }
    if (searchTerms && resetSearchTermBtn) {
      const terms = searchTerms.toLowerCase();
      filters.push((destination) => (this.filterBySearchTerms(destination, terms)));
    }

    const destinations = destinationList.data;
    if (destinations !== undefined) {
      if (destinations.length < limit && !isLastPage && destinations.length > 0) {
        this.setState({
          isLastPage: true,
        });
      } else if (destinations.length === limit && isLastPage) {
        this.setState({
          isLastPage: false,
        });
      }
      return destinations;
    }
    return [];
  }

  getFilteredInstallationDocuments() {
    const { installationDocuments } = this.state;

    return installationDocuments;
  }

  filterByCustomerName(destination, filter) {
    const { customer: { name } } = destination;
    return filter.some((item) => item === name);
  }

  filterByEndCustomerName(destination, filter) {
    const { companyName } = destination;
    return filter !== '' ? filter : filter.some((item) => item === companyName);
  }

  filterBySearchTerms(destination, filter) {
    const {
      companyName, streetAddress, city, postalCode,
    } = destination;

    const searchAttributes = [
      companyName,
      streetAddress,
      city,
      postalCode,
    ];

    return searchAttributes.find((attr) => attr.toLowerCase()
      .includes(filter)) !== undefined;
  }

  onSearchUpdated = (searchCriteria, searchDestinationsOnly = false) => {
    const { session: { isAdmin = false } } = this.props;
    const { searchTerms } = searchCriteria;
    const normalizedSearchTerm = searchTerms?.trim();
    this.setState({ page: 1, isLastPage: false });
    this.setState({ resetSearchTermBtn: (searchTerms !== undefined) });
    if (!searchDestinationsOnly && normalizedSearchTerm && isAdmin === true) {
      fetch(`${BASE_URL}/installationdocument/search/${normalizedSearchTerm.toUpperCase()}`, createRequestProperties(null))
        .then((response) => {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        })
        .then((installationDocuments) => {
          if (installationDocuments.length > 0) {
            this.setState({
              installationDocuments: Object.values(installationDocuments),
              showOnlyInstallationDocuments: true,
            });
          } else {
            this.onSearchUpdated(searchCriteria, true);
          }
        })

        .catch((err) => {
          console.log(err);
          this.onSearchUpdated(searchCriteria, true);
        });
    } else {
      const { page, limit } = this.state;
      const { requestDestinationList } = this.props;
      const { selectedCustomer } = searchCriteria;

      if (selectedCustomer !== undefined) {
        this.setState({ searched: true });
        if (selectedCustomer.length === 0) {
          this.setState({ page: 1, searched: true });
        }
        requestDestinationList(1, limit, selectedCustomer);
        this.setState({
          destinationFilters: searchCriteria,
          installationDocuments: [],
          showOnlyInstallationDocuments: false,
          selectedCustomersFilterItems: selectedCustomer,
        });
      } else {
        const { selectedCustomersFilterItems } = this.state;
        const { customerName, endCustomerName } = searchCriteria;
        const { requestDestinationList } = this.props;
        const { searched } = this.state;
        this.setState({ searchText: searchCriteria.searchTerms });

        if (searchCriteria.searchTerms !== undefined) {
          let customers = selectedCustomersFilterItems;
          if (customers === undefined || customers.length === 0) {
            customers = customerName === null ? '' : customerName;
          }

          if (searchCriteria.searchTerms.trim() !== '') {
            this.setState({
              searched: true, searchText: searchCriteria.searchTerms.trim(), resetSearchTermBtn: true, page: 1,
            });
            this.setState({ page: 1 });
            requestDestinationList(1, limit, customers, endCustomerName, searchCriteria.searchTerms.trim());
          }
        } else if (searchCriteria.searchTerms === undefined && searched && customerName === undefined) {
          requestDestinationList(page, limit, [], undefined);
          this.setState({ searched: false });
        } else if (customerName !== undefined && endCustomerName !== undefined) {
          this.setState({ page: 1 });
          requestDestinationList(1, limit, [customerName], endCustomerName, undefined);
        } else if (searchCriteria.searchTerms === undefined && customerName !== undefined) {
          this.setState({ page: 1 });
          requestDestinationList(1, limit, selectedCustomersFilterItems, undefined, undefined);
        }
        this.setState({
          destinationFilters: searchCriteria,
          installationDocuments: [],
          showOnlyInstallationDocuments: false,
        });
      }
    }
  };

  groupDestinationsByStatus(destinations) {
    const groupedDestinations = {
      normal: [],
      pending: [],
    };

    destinations.forEach((destination) => {
      const { internalStatus } = destination;

      if (internalStatus.toLowerCase() !== 'ordered') {
        groupedDestinations.normal.push(destination);
      }
    });

    return groupedDestinations;
  }

  customPerPageEvt = (evt) => {
    const { requestDestinationList } = this.props;
    const {
      page, selectedCustomersFilterItems, limit, maxRecord,
    } = this.state;
    if (evt.target.value <= maxRecord) {
      this.setState({ limit: evt.target.value });
      if (evt.key === 'Enter' && evt.target.value > 0) {
        this.setState({ limit: Number(evt.target.value) });
        requestDestinationList(page, limit, selectedCustomersFilterItems);
      }
    }
  }

  customPerPageNumberBox() {
    return (
      <div>
        <div className="custom-per-page-box">
          <input type="number" onChange={this.customPerPageEvt} onKeyDown={this.customPerPageEvt} value={this.state.limit} style={{ width: '50px' }} />
        </div>
      </div>
    );
  }

  renderPageLimitList() {
    const { translate } = this.props;
    return (
      <div className="row" style={{ paddingBottom: '20px', paddingTop: '10px', paddingLeft: '30px' }}>
        <div className="tableElements">
          <div className="floatLeft">
            <div style={{ paddingRight: '4px', fontWeight: 'bold', float: 'left' }}>
              {translate('work_list.search.rows-label')}
            </div>
            <div style={{
              paddingRight: '4px', fontWeight: 'bold', float: 'left', display: 'flex',
            }}>
              { this.customPerPageNumberBox() }
            </div>
            <div style={{
              paddingRight: '4px',
              fontWeight: 'bold',
              float: 'right',
              position: 'relative',
              right: '95px',
            }} />
          </div>
        </div>
      </div>
    );
  }

  renderPagination = () => {
    const {
      page, isLastPage, isDataLoading, limit,
    } = this.state;
    const { translate, destinationList } = this.props;
    return (
      <div>
        <div style={{ paddingBottom: '20px', paddingTop: '10px' }}>
          <div>
            <div className="col-sm-12"
                 style={{ textAlign: 'right', paddingBottom: 15 }}>
              <button className="button-link primary-color inline-block bold"
                      disabled={page === 1 || isDataLoading}
                      onClick={this.firstClicked}
                      type="button">
                {translate('work_list.search.first_page')}
              </button>
              <button className="button-link primary-color inline-block bold"
                      disabled={page === 1 || isDataLoading}
                      onClick={this.prevClicked}
                      style={{ padding: '0 0 0 15px' }}
                      type="button">
                {translate('work_list.search.previous_page')}
              </button>
              <span style={{ padding: '0 0 0 15px' }}
                    className="primary-color inline-block bold">
                {page}
              </span>
              <button className="button-link primary-color inline-block bold"
                      disabled={isLastPage || isDataLoading || (destinationList !== undefined ? (destinationList.length < limit) : false)}
                      onClick={this.nextClicked}
                      style={{ padding: '0 0 0 15px' }}
                      type="button">
                {translate('work_list.search.next_page')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  firstClicked = () => {
    this.setState({ page: 1 });
    const {
      limit, selectedCustomersFilterItems, destinationFilters, searchText,
    } = this.state;
    const { endCustomerName } = destinationFilters;
    const { requestDestinationList } = this.props;
    this.setState({ isLastPage: false });
    requestDestinationList(1, limit, selectedCustomersFilterItems, endCustomerName !== '' ? endCustomerName : undefined, searchText !== '' ? searchText : undefined);
  };

  prevClicked = () => {
    const {
      page, limit, selectedCustomersFilterItems, destinationFilters, searchText,
    } = this.state;
    const { endCustomerName } = destinationFilters;
    this.setState({ page: page - 1 });
    const { requestDestinationList } = this.props;
    requestDestinationList((page - 1), limit, selectedCustomersFilterItems, endCustomerName !== '' ? endCustomerName : undefined, searchText !== '' ? searchText : undefined);

    this.setState({
      isLastPage: false,
    });
  };

  nextClicked = () => {
    const {
      page, limit, selectedCustomersFilterItems, destinationFilters, searchText,
    } = this.state;
    const { requestDestinationList, destinationList } = this.props;
    const { endCustomerName } = destinationFilters;

    this.setState({ page: page + 1 });

    if (selectedCustomersFilterItems.length > page) {
      this.setState({ isLastPage: false });
    } else if (destinationList.length < limit) {
      this.setState({ isLastPage: true });
    }

    requestDestinationList((page + 1), limit, selectedCustomersFilterItems, endCustomerName !== '' ? endCustomerName : undefined, searchText !== '' ? searchText : undefined);
  };

  resetFilterHandler = () => {
    const {
      page, limit, destinationFilters, selectedCustomersFilterItems,
    } = this.state;
    const { requestDestinationList } = this.props;
    const { endCustomerName } = destinationFilters;
    this.setState({
      destinationFilters: {
        searchTerms: undefined,
      },
      searchTerms: undefined,
      searchText: undefined,
      resetSearchTermBtn: false,
    });
    requestDestinationList(page, limit, selectedCustomersFilterItems, endCustomerName, undefined);
  }

  resetEverything = () => {
    const { limit, selectedCustomersFilterItems, endCustomerName } = this.state;
    const { requestDestinationList } = this.props;
    this.setState(
      {
        page: 1,
        limit: 10,
        maxRecord: 100,
        isLastPage: false,
        selectedCustomersFilterItems: [],
        isDataLoading: false,
        destinationFilters: {
          customerName: '',
          endCustomerName: '',
          searchTerms: '',
        },
        searched: false,
        searchText: '',
        installationDocuments: [],
        showOnlyInstallationDocuments: false,
        mainMenuClicked: this.props.mainMenuClicked,
        resetSearchTermBtn: false,
      },
    );
    requestDestinationList(1, limit, selectedCustomersFilterItems, endCustomerName, undefined);
  }

  render() {
    const { translate, session: { isAdmin = false }, destinationList = [] } = this.props;
    const { searched, resetSearchTermBtn } = this.state;
    const destinations = this.getFilteredDestinations()
      .map((destination) => ({
        ...destination,
        key: destination.id,
        link: `/destination/${destination.id}/frontpage`,
      }));

    const installationDocuments = this.getFilteredInstallationDocuments()
      .map((installationDocument) => ({
        ...installationDocument,
        key: installationDocument._id,
        link: `/installationDocument/${installationDocument.devices[0].shipmentId}/${installationDocument.id}`,
      }));

    const destinationGroups = this.groupDestinationsByStatus(destinations);

    const pendingDestinationList = destinationGroups.pending.length > 0 && (
      <div className="col-sm-12">
        <List data={destinationGroups.pending}
              title={isAdmin ? translate('requires_action') : translate('order_pending.plural')}>
          <DestinationListItem additionalInfo />
        </List>
      </div>
    );

    let hasDestinationData;
    const shouldShowInstallationDocument = this.state.showOnlyInstallationDocuments;
    if (destinationList.hasData !== undefined) {
      hasDestinationData = destinationList.hasData;
    }

    return (
      <div>
        <div className="container">
          {false && (
            <div className="row">
              <div className="col-sm-12">
                <h1>{translate('destination.plural')}</h1>
              </div>
            </div>
          )}
          <SearchTools searched={searched} resetSearchTerm={resetSearchTermBtn} resetFilter={this.resetFilterHandler} searchUpdated={this.onSearchUpdated} />
          <div className="row">
            <div className="col-sm-12">
              <div className="row">
                {shouldShowInstallationDocument === false
                  && (
                    <div className="col-sm-12">
                      { this.renderPageLimitList() }
                      { this.renderPagination() }
                      <List hasDestinationData={hasDestinationData}
                            title={`${translate('destination.plural')}`}
                            sectionName="home"
                            data={destinationGroups.normal}>
                        <DestinationListItem additionalInfo />
                      </List>
                    </div>
                  )}
                {!isAdmin && pendingDestinationList}
              </div>
            </div>
            {(installationDocuments.length > 0 || shouldShowInstallationDocument === true)
              && (
                <div className="col-sm-12">
                  <List title={translate('service_report.search.type_installationDocument')}
                        data={installationDocuments}>
                    <InstallationDocumentModalItem />
                  </List>
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const hasLanguages = Array.isArray(locale.languages) && locale.languages.length > 0;

  return {
    translate: hasLanguages ? getTranslate(locale) : () => '',
    currentLanguage: hasLanguages ? (getActiveLanguage(locale) || {}).code : 'fi',
    destinationList: state.destination?.destinationList || [],
    installationDocumentList: state.installationDocuments || [],
    session: state.session.session || {},
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  disableSubNavbar,
  requestDestinationList,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);
